import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import ReviewsSlider from "./components/reviews-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import LinesSlider from './components/lines-slider';
import ScrollInView from "./components/scroll-in-view";
import TextImageRedirectionSlider from './components/text-image-redirection-slider';
import PartnersSlider from './components/partners-slider';
import DeviceManager from "./utils/device-manager";
import "./components/categories-dropdown";
import "./components/map-marker";
import "./components/anchor";
import "./components/has-chapo";

//Home 
import HomeReassurancesSlider from './components/home-reassurances-slider';
import HomeBlogSlider from './components/home-blog-slider';

// (function ($) {
	// window.$ = $;

$(function () {

	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	}
	
	const instanciateComponents = () => {
		// General components
		// const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);

		// Home reassurances slider component
		// const $homesReassurancesSliders = $(".home-reassurances-section .container");
		// if ($homesReassurancesSliders.length) {
		// 	$homesReassurancesSliders.each(function (index, el) {
		// 		const homesReassurancesSlider = new HomeReassurancesSlider($(el));
		// 	});
		// }

		// Home blog slider component
		const $homeBlogSliders = $(".home-blog__content");
		if ($homeBlogSliders.length) {
			$homeBlogSliders.each(function (index, el) {
				const homeBlogSlider = new HomeBlogSlider($(el));
			});
		}
		
		// Lines slider component
		const $lineSliders = $(".lines-section__container");
		if ($lineSliders.length) {
			$lineSliders.each(function (index, el) {
				const linesSlider = new LinesSlider($(el));
			});
		}

		// Texte image redirection slider component
		const $textImageRedirectionSliders = $(".text-image-redirection__container");
		if ($textImageRedirectionSliders.length) {
			$textImageRedirectionSliders.each(function (index, el) {
				const textImageRedirectionSlider = new TextImageRedirectionSlider($(el));
			});
		}

		// Partners slider component
		const $partnersSliders = $(".footer__partner-container");
		if ($partnersSliders.length) {
			$partnersSliders.each(function (index, el) {
				const partnerSlider = new PartnersSlider($(el));
			});
		}

		// Reviews slider component
		const $reviewsSlider = $(".reviews-slider");
		if ($reviewsSlider.length) {
			$reviewsSlider.each(function (index, el) {
				const reviewsSlider = new ReviewsSlider($(el));
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}
	}

	bootstrapApp();
	instanciateComponents();
});

// })(jQuery);
